import{MultiSelectionFilters as o}from"./consts.js";const s=s=>o.includes(s);export{s as isMultiFilter};
